import React, { CSSProperties, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import './button.css';

interface ButtonCSSProperties extends CSSProperties {
    width: string;
}

export const ButtonBase = ({
    className,
    onClick,
    ...props
}: React.ComponentPropsWithoutRef<'div'>) => {
    const [state, setState] = useState<'' | 'clicked' | 'failure' | 'success'>('');
    const onClickWithFeedback = onClick
        ? (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              setState('clicked');
              const result: any = onClick(e);
              if (!(result instanceof Promise)) {
                  setTimeout(() => setState(''), 500);
              } else {
                  result.then(
                      (args) => {
                          setState('success');
                          return Promise.resolve(args);
                      },
                      (error) => {
                          setState('failure');
                          return Promise.reject(error);
                      }
                  );
                  setTimeout(() => setState(''), 700);
              }
              return result;
          }
        : undefined;
    return <div className={`${className} ${state}`} onClick={onClickWithFeedback} {...props} />;
};

interface ButtonProps extends React.ComponentPropsWithoutRef<'div'> {
    style: ButtonCSSProperties;
    theme: 'blue' | 'orange' | 'red' | 'disabled' | 'soft' | 'cancel';
}
export const Button = ({ className, theme, ...props }: ButtonProps) => {
    return <ButtonBase className={`button ${theme} ${className || ''}`} {...props} />;
};
Button.defaultProps = { theme: 'blue' };

export const Cancel = ({ style, ...props }: React.ComponentPropsWithoutRef<'div'>) => {
    return (
        <Button style={{ ...style, width: 'inherit' }} {...props} theme="cancel">
            <ArrowBackIcon sx={{ fontSize: 14 }} />
            Cancel
        </Button>
    );
};
